// accordion
jQuery(function($){
  var $accordion = $('.js-accordion');
  if ($accordion.length) {
    var $accordionTrigger = $accordion.find('.js-accordion-trigger');
    $accordionTrigger.on('click', function() {
      $(this).parent('.js-accordion').toggleClass('is-active');
    });
  }
});
